import type { SampleAdherence } from '@/versions/v1/schema/unit-operation';
import { Pill, type PillProps } from '@/design-system/Pill';

export type StateChipSpec = {
  label: string;
  tone: PillProps['tone'];
};

/** Seven-state sample adherence map — deck cell text → canonical SampleAdherence chip. */
export const SAMPLE_ADHERENCE_CHIP: Record<SampleAdherence, StateChipSpec> = {
  REG: { label: 'REG', tone: 'success' },
  PENDING: { label: 'LIMS?', tone: 'warning' },
  LATE: { label: 'LATE', tone: 'warning' },
  MISS: { label: 'MISS', tone: 'danger' },
  DUE: { label: 'DUE', tone: 'warning' },
  UPCOMING: { label: 'UPCOMING', tone: 'default' },
  'N/A': { label: 'N/A', tone: 'default' },
};

/** Map deck register / grid cell text to the seven-state union (pure). */
export function parseSampleAdherence(cell: string): SampleAdherence | null {
  const normalized = cell.trim().toUpperCase();
  if (normalized === 'REG' || normalized === '✓REG') return 'REG';
  if (normalized === 'LIMS?' || normalized === 'PENDING') return 'PENDING';
  if (normalized === 'LATE') return 'LATE';
  if (normalized === 'MISS' || normalized === '✗MISS') return 'MISS';
  if (normalized === 'DUE' || normalized === '◉DUE') return 'DUE';
  if (normalized === 'UPCOMING' || normalized === '--') return 'UPCOMING';
  if (normalized === 'N/A') return 'N/A';
  return null;
}

export function StateChip({ state }: { state: SampleAdherence }) {
  const spec = SAMPLE_ADHERENCE_CHIP[state];
  return <Pill tone={spec.tone}>{spec.label}</Pill>;
}
